import React, { useEffect } from 'react';
import Datas from '../data/testimonial/testimonial-slider.json';
import { Container, Row, Col } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import { Styles } from "./styles/testimonialSlider.js";
import { useDispatch, useSelector, connect } from 'react-redux';
import { getTestimonials, showLoading, hideLoading } from '../redux/actions/testimonial';
import axios from 'axios';

const TestimonialSlider = () => {
    const testimonials = useSelector(state => state.allTestimonials.testimonials);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchAllTestimonials = async () => {
            dispatch(showLoading());
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/testimonials/find-all`).then((res) => {
                dispatch(getTestimonials(res.data));
                dispatch(hideLoading());

            }).catch(error => {
                console.error(error);
            });
        };
        fetchAllTestimonials();
    }, [dispatch]);


        const settings = {
            slidesPerView: 2,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            spaceBetween: 30,
            watchSlidesVisibility: true,
            pagination: {
                el: '.slider-dot.text-center',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 2
                }
            }
        };

        return (
            <Styles>
                {/* Testimonial Slider */}
                <section className="testimonial-area" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${Datas.backgroundImage})` }}>
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>{Datas.secTitle.toUpperCase()}</h4>
                                </div>
                            </Col>
                            <Col md="12" className="testimonial-slider">
                                <Swiper {...settings}>
                                    {
                                        testimonials !== null && testimonials.length > 0 ? testimonials.map((data, i) => (
                                            <div className="slider-item" key={i}>
                                                <div className="desc">
                                                    <h5>{data.testimonialTitle}</h5>
                                                    <p>{data.testimonialDesc}</p>
                                                </div>
                                                <div className="writer">
                                                <img className="slider-image" src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.authorImg.substring(data.authorImg.indexOf("/uploads"))}`} alt={data.testimonialTitle} />

                                                    {/* <img src={process.env.PUBLIC_URL + `/assets/images/${data.authorImg}`} className="slider-image" alt={data.authorImg} /> */}
                                                    <h6>{data.authorName}</h6>
                                                    <p>{data.authorTitle}</p>
                                                </div>
                                            </div>
                                        )) : ""
                                    }
                                </Swiper>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
}

export default TestimonialSlider
